var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckmarkCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: " checkmark-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0285 6.79588L8.19045 10.5226L6.9657 8.95813C6.7107 8.63113 6.2382 8.57413 5.9127 8.82987C5.58645 9.08488 5.5287 9.55663 5.78445 9.88212L7.6077 12.2124C7.7502 12.3939 7.9677 12.4996 8.1987 12.4996H8.20395C8.4357 12.4989 8.6547 12.3894 8.79495 12.2041L12.2217 7.70413C12.4729 7.37413 12.4092 6.90463 12.0792 6.65338C11.7484 6.40213 11.2789 6.46663 11.0285 6.79588ZM9 15.5C5.69175 15.5 3 12.8082 3 9.5C3 6.19175 5.69175 3.5 9 3.5C12.3082 3.5 15 6.19175 15 9.5C15 12.8082 12.3082 15.5 9 15.5ZM9 2C4.85775 2 1.5 5.3585 1.5 9.5C1.5 13.6415 4.85775 17 9 17C13.1423 17 16.5 13.6415 16.5 9.5C16.5 5.3585 13.1423 2 9 2Z",
    fill: "#128A08"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkCircle);
export default __webpack_public_path__ + "static/media/checkmark-circle.5599a73d8f668163f3f4975b7f393be4.svg";
export { ForwardRef as ReactComponent };